/* @ngInject */
export default function PublicFeedbackCriteriaLectureComponentModel(
  _,
  LectureComponentBaseModel,
) {
  class PublicFeedbackCriteriaLectureComponent extends LectureComponentBaseModel {
    constructor(attributes, isSample = false, useDefaults = false) {
      const defaults = {
        type: 'PublicFeedbackCriteriaLectureComponent',
        editFormTemplateUrl: 'lecture_pages/templates/components/video-practice-evaluation-modal.html',
        editFormController: 'VideoPracticeEvaluationCtrl',
        publicFeedback: {},
        canBeCopied: true,
      };
      super(_.extend({}, defaults, attributes));
    }

    getPayload() {
      const publicFeedback = {
        ...this.publicFeedback, // publicFeedback is the field returned by API
        ...this.publicFeedback,
      };

      return { publicFeedback };
    }

    saveDraft() {
    //  return this.save();
    }

    toggleToDo() {
      this.publicFeedback.isTodo = !this.publicFeedback.isTodo;
      this.save();
    }
  }

  PublicFeedbackCriteriaLectureComponent.iconClass = 'icon-peer-feedback';
  PublicFeedbackCriteriaLectureComponent.showModalBeforeCreate = true;
  PublicFeedbackCriteriaLectureComponent.descriptionKey = 'LECTURE_PAGES.COMPONENTS.PEER_EVALUATION.VIDEO_PRACTICE.DESCRIPTION';
  PublicFeedbackCriteriaLectureComponent.unavailabilityDescriptionKey = 'LECTURE_PAGES.COMPONENTS.PEER_EVALUATION.VIDEO_PRACTICE.UNAVAILABLE';
  return PublicFeedbackCriteriaLectureComponent;
}
